/**
 * @generated SignedSource<<d5ab1ca3504e16da58d7888c77586f82>>
 * @relayHash 5cd4fa182e469a3e4b0d82a8db8d8b31
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ferrum/417.0.0-2023-06-02T01:22:30.591Z/tradeGeneralOnboardingQuery

import { ConcreteRequest, Query } from 'relay-runtime';
export type tradeGeneralOnboardingQuery$variables = {
  userId: string;
};
export type tradeGeneralOnboardingQuery$data = {
  readonly viewer: {
    readonly user: {
      readonly verifiedTradeSubStatus: string | null;
    } | null;
  };
};
export type tradeGeneralOnboardingQuery = {
  response: tradeGeneralOnboardingQuery$data;
  variables: tradeGeneralOnboardingQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "userId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "userId",
    "variableName": "userId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "verifiedTradeSubStatus",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "tradeGeneralOnboardingQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "tradeGeneralOnboardingQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "ferrum/417.0.0-2023-06-02T01:22:30.591Z/tradeGeneralOnboardingQuery",
    "metadata": {},
    "name": "tradeGeneralOnboardingQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "64ddc90929301867e13b3c6be16fd328";

export default node;
